import React, {Children, cloneElement} from 'react'
import styled from 'styled-components'
import Icons from '../Icons'

const Container = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
`
const StyledCancelIcon = styled.div`
padding-left: 10px;
padding-right: 6px;
-webkit-margin-end: 10px;
align-items: center;
cursor: pointer;
display: ${props => (props.hidden ? 'none' : 'flex')};
`

const StyledTabHeader = styled.div`
  display: flex;
  flex: 1;
  box-sizing: border-box;
  padding: 8px;
  border-bottom: 2px solid #ced2d8;
`

const StyledTabPanel = styled.div`
  height: 100%;
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
`

const Tabs = ({children, activeIndex, onActive}) => {
  const activateTab = index => {
    if (onActive) {
      onActive(index)
    }
  }

  let activeContent = null
  const tabs = Children.map(children, (tab, index) => {
    if (!tab) return undefined

    const tabProps = tab.props || {}
    const isTabActive = index === activeIndex

    if (isTabActive) {
      activeContent = tabProps.children
    }

    return cloneElement(tab, {
      active: isTabActive,
      onActivate: () => activateTab(index)
    })
  })
	  
  return (
    <Container role="tree" aria-label="Search Results">
      <StyledTabHeader>{tabs}</StyledTabHeader>
      <StyledTabPanel>{activeContent}</StyledTabPanel>
    </Container>
  )
}

export default Tabs

Tabs.defaultProps = {
  activeIndex: 0
}
